import React, { useEffect, useRef, useState, useMemo, useCallback } from 'react';
import Avatar from '../../components/Avatar/Avatar';
import format from 'date-fns/format';
import { toast } from 'react-toastify';
import ProtectedPageSidebar from '../../components/Sidebar/ProtectedPageSidebar';
import VideoService from '../../service/VideoService';
import Toast from '../../../common/utils/Toast';
import { VideoSidebarMenu } from './VideoSidebarMenu/VideoSidebarMenu';
import { VideoHeader } from './VideoHeader/VideoHeader';
import styles from './Video.module.scss';
import { useUIContext } from '../../context/UIContext';
import { useUserContext } from '../../context/UserContext';
import { Icon } from '../../components/Icon';
import SharingModal from '../../components/_stateful/SharingModal';
import SharingModalContent from '../../components/_stateful/SharingModal/SharingModalContent';
import queryString from 'query-string';
import { CustomButton } from '../../components/Button/Button';
import MobileHeader from '../../components/MobileHeader';
import DotsBtn from '../../components/Menu/DotsBtn';
import useOutsideClick from '../../../common/hooks/useOutsideClick';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import MoveModal from '../../components/MoveModal/MoveModal';
import MoveModalContent from '../../components/MoveModalContent/MoveModalContent';
import ConfirmMoveModalContent from '../../components/ConfirmMoveModalContent/ConfirmMoveModalContent';
import CardMenu from '../../components/CardMenu/CardMenu';
import { PreferenceList } from './VideoSidebarMenu/PreferenceSwiches/PreferenceList';
import { useLibraryContext } from '../../context/LibraryContext';
import cx from 'classnames';
import ResourceHelper from '../../utils/ResourceHelper';
import { useTranslation } from 'react-i18next';
import CustomThumbnailModal from '../../components/CustomThumbnailModal/CustomThumbnailModal';
import CustomThumbnailModalContent from '../../components/CustomThumbnailModalContent/CustomThumbnailModalContent';
import Modal from '../../components/Modal';
import { FOLDER_USER_ROLE, STORY_USER_RELATION } from '../../constants/UserRoles';
import DeleteSharedVideoModal from '../../components/DeleteSharedVideoModal/DeleteSharedVideoModal';
import { approvalStatuses } from '../../features/Dashboard/components/VideosFilter/constants';
import SubmitForReviewModal from '../../components/SubmitForReviewModal/SubmitForReviewModal';
import DownloadModal from '../../components/_stateful/DownloadModal';
import DownloadModalContent from '../../components/_stateful/DownloadModal/DownloadModalContent';
import Comments from '../../components/Comments';
import { withProtectionCheck } from '../../hocs/withProtectionCheck';
import ApprovalsFeedback from './VideoSidebarMenu/ApprovalsFeedback/ApprovalsFeedback';
import ReviewVideo from './VideoSidebarMenu/ReviewVideo/ReviewVideo';
import { ToastNotification } from '../../components/Toast/Toast';
import { parseString } from '../../utils/stringHelper';
import AnalyticsInfo from '../../components/AnalyticsInfo/AnalyticsInfo';
import Reactions from '../../components/Comments/Reactions/Reactions';
import ReactionPicker from '../../components/Comments/CommentActions/ReactionPicker';
import CmsAPI from '../../../common/apis/CmsAPI';
import { LoaderContent } from '../../components/LoaderContent/LoaderContent';
import { useCallToActionContext } from '../../context/CallToActionContext';
import VideoCallActionsControls from './VideoCallActionsControls/VideoCallActionsControls';
import useAutosizeTextArea from '../../hooks/useAutosizeTextarea';
import Content from '../../components/Content/Content';
import { getCurrentActions } from '../../utils/CallToActionHelper';
import { getCurrentVoiceovers } from '../../utils/VoiceoversHelper';
import useThumbnailChooserHook from '../../hooks/useThumbnailChooserHook';
import { useChaptersContext } from '../../context/ChaptersContext';
import { useVoiceoverContext } from '../../context/VoiceoverContext';
import VideoVoiceoversControls from './VideoVoiceoversControls/VideoVoiceoversControls';
import TagsControls from '../CompanySettings/components/Tags/TagsControls/TagsControls';
import VormatsAPI from '../../../common/apis/VormatsAPI';
import VideoDetailsPlayer from '../../features/Dashboard/components/VideoDetailsPlayer/VideoDetailsPlayer';
import { uploadVideoDirectly } from '../../service/VideoUploadingService';
import { EDITED } from '../../features/Dashboard/const';
import { ENTER_KEY_CODE, ESCAPE_KEY_CODE } from '../../constants/common';
import { useInPlayerCommentContext } from '../../context/InPlayerCommentContext';
import * as Sentry from '@sentry/react';

const initialState = {
  videoDetail: {
    uuid: '',
    createdOn: '',
    videoPath: '',
    alternateURL: '',
    title: '',
    config: {
      canDownload: true,
      canComment: false,
      canSeeAnalytics: true,
      canShare: true,
      disableGIF: false,
      shareVideoPlayerOnly: true,
      stopSharing: false,
    },
  },
  anonRex: {
    id: '',
    createDate: '',
    updateDate: '',
    videoPath: '',
    name: '',
    description: '',
  },
  editable: {
    id: '',
    name: '',
    isEdit: false,
  },
  isActive: true,
  shareModal: {
    open: false,
    id: '',
    videoid: '',
    thumbnailURL: '',
    url: '',
    trackerURL: '',
  },
  downloadModal: {
    open: false,
  },
  customThumbnailModal: {
    open: false,
    id: '',
    videoid: '',
    thumbnailURL: '',
    url: '',
    trackerURL: '',
  },

  isLoading: {
    loading: false,
  },
};

const videoToMoveInit = {
  videoId: '',
  videoName: '',
  videoIndex: -1,
  folder: '',
};

const Video = props => {
  const { videoId, scenes, videoDetails, permissions, role, initialVideoConfig: videoConfig, ...rest } = props;
  const { miniSidebar } = useUIContext();
  const [init, setInit] = useState(false);
  const [shareModal, setShareModal] = useState(initialState.shareModal);
  const [downloadModal, setDownloadModal] = useState(initialState.downloadModal);
  const [video, setVideo] = useState(initialState.videoDetail);
  const [editable, setEditable] = useState(initialState.editable);
  const [videoToMove, setVideoToMove] = useState(videoToMoveInit);
  const [size, setSize] = useState(0);
  const [isEditThumbnail, setIsEditThumbnail] = useState(false);
  const [isPreferencesEditor, setIsPreferencesEditor] = useState(false);

  const [isVideoProcessing, setIsVideoProcessing] = useState(false);

  const [description, setDescription] = useState('');
  const [isDescriptionChanged, setIsDescriptionChanged] = useState(false);

  const [searchModal, setSearchModal] = useState(false);

  const mediaMatch = window.matchMedia('(max-width: 900px)');
  const [isMobileView] = useState(mediaMatch.matches);
  const [checkedSaveStatus, setCheckedSaveStatus] = useState(false);

  const [showMenu, setShowMenu] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);
  const [showApprovalsFeedback, setShowApprovalsFeedback] = useState(false);
  const [showReviewMode, setShowReviewMode] = useState(false);

  const [moveModal, setMoveModal] = useState(false);
  const [confirmMoveModal, setConfirmMoveModal] = useState(false);

  const [showShareBtn, setShowShareBtn] = useState(true);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);

  const [showSubmitForReviewModal, setShowSubmitForReviewModal] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  const reactLocation = useLocation();
  const history = useHistory();

  const hasHls = useMemo(() => video?.videoHls !== null, [video]);

  const [analyticsInfo, setAnalyticsInfo] = useState([]);
  const [showAnalyticsInfo, setShowAnalyticsInfo] = useState(false);

  const [assignments, setAssignments] = useState([]);
  const [isVideoDescriptionProcessing, setIsVideoDescriptionProcessing] = useState(false);
  const descriptionRef = useRef();
  const [isEditDescription, setIsEditDescription] = useState(false);

  const [isTagsLoading, setIsTagsLoading] = useState(false);
  const [tags, setTags] = useState(false);
  const [commentsWithTimestamp, setCommentsWithTimestamp] = useState({});

  const { startAddNotesMode } = useInPlayerCommentContext();

  const quiteRecursionRef = useRef();

  const [latestExternalUpload, setLatestExternalUpload] = useState(null);
  const [videoVersion, setVideoVersion] = useState(null);
  const [editorPreference, setEditorPreference] = useState(null);

  const pageActiveRef = useRef(true);

  const stateVideoPath = useMemo(() => videoVersion === EDITED ? latestExternalUpload?.url : video.videoPath, [videoVersion, latestExternalUpload, video]);

  useAutosizeTextArea(descriptionRef.current, description, isEditDescription, isDescriptionChanged);

  const { t } = useTranslation();

  const { folderToMove, updateFolderToMove } = useLibraryContext();
  const {
    isCallToActionOpened,
    updateCallActions,
    updateInitialCallActions,
    resetCallActions,
    callActions,
    isCallActionsChanged,
    closeCallToAction,
    openCallToAction,
  } = useCallToActionContext();

  const {
    chapters,
    openChaptersEditor,
    updateInitialChapters,
    isChaptersEditor,
    hasChanged,
    closeChaptersEditor,
  } = useChaptersContext();

  const {
    isVoiceoverOpened,
    updateVoiceovers,
    updateInitialVoiceovers,
    closeVoiceover,
    openVoiceover,
    updateGeneralVoiceoverId,
    changeSelectedVoiceover,
    changeVoiceoversLoading,
  } = useVoiceoverContext();

  const [reply, setReply] = useState({ show: false, timestamp: false });

  const handleReply = () => {
    handleScrollToComment();
    setReply({ show: true, timestamp: true });
  };

  const [reactions, setReactions] = useState([]);
  const [selectedReactions, setSelectedReactions] = useState('');
  const [localStorageStoryReactions, setLocalStorageStoryReactions] = useState(JSON.parse(localStorage.getItem(videoId)));
  const [reactionStatistics, setReactionStatistics] = useState([]);
  const [reactionStatisticsBar, setReactionStatisticsBar] = useState([]);

  const [miniRightSidebar, setMiniRightSidebar] = useState(false);

  const [hasRunningJobs, setHasRunningJobs] = useState(false);

  const [waveform, setWaveform] = useState(null);

  const menuRef = useRef(null);
  useOutsideClick(menuRef, () => {
    if (showMenu) {
      setShowMenu(false);
    }
  });

  const editableRef = useRef(null);

  const {
    user,
    isApprovalFlowEnabled,
    isReviewerUser,
    appConfig,
    logFirebaseEvent,
    isViewAnalyticsEnabled,
    companyTags,
    isVideoTagsEnabled,
  } = useUserContext();

  const { userId } = useMemo(() => {
    if (user) {
      const userId = user.username;
      return { userId };
    }
    return {};
  }, [user]);

  const isVideoOwner = useMemo(() => role === STORY_USER_RELATION.OWNER.TYPE, [role]);

  const isUserHasEditingRights = useMemo(
    () =>
      role === STORY_USER_RELATION.OWNER.TYPE ||
      role === STORY_USER_RELATION.FOLDER_OWNER.TYPE ||
      role === STORY_USER_RELATION.FOLDER_EDITOR.TYPE ||
      role === STORY_USER_RELATION.FOLDER_ADVANCED_EDITOR.TYPE ||
      permissions.updateStory,
    [role]
  );
  const isUserHasAdvancedEditingRights = useMemo(() => {
    return isUserHasEditingRights && role !== STORY_USER_RELATION.FOLDER_EDITOR.TYPE;
  }, [isUserHasEditingRights, role]);

  const {
    customThumbnailModal,
    closeThumbnailModal,
    openThumbnailModal,
    processingThumbnail,
    customStaticLoading,
    customAnimatedLoading,
    onSelect,
  } = useThumbnailChooserHook({ video, setVideo });

  const isEditingDisabled = useMemo(() => {
    if (video.scenes && !isVideoProcessing) {
      const sceneHls =
        ResourceHelper.getResourceByLabel(video.scenes[0], 'trimmedHls')?.url ||
        ResourceHelper.getResourceByLabel(video.scenes[0], 'hls')?.url;
      return hasRunningJobs ? false : (!sceneHls && video.status === 'READY' && !video.videoHls);
    }
    return false;
  }, [video, hasRunningJobs, isVideoProcessing]);

  const isPreExistedStatus = useMemo(() => video?.approvalStatus === approvalStatuses.PRE_EXISTED.TYPE, [video]);
  const isConceptStatus = useMemo(() => video?.approvalStatus === approvalStatuses.CONCEPT.TYPE, [video]);
  const isInReviewStatus = useMemo(() => video?.approvalStatus === approvalStatuses.IN_REVIEW.TYPE, [video]);
  const isDeclinedStatus = useMemo(() => video?.approvalStatus === approvalStatuses.DECLINED.TYPE, [video]);
  const isApprovedStatus = useMemo(() => video?.approvalStatus === approvalStatuses.APPROVED.TYPE, [video]);

  const approvalsTitle = useMemo(() => {
    if (video?.approvalStatus === approvalStatuses.CONCEPT.TYPE) {
      return t('review.status.concept');
    }

    if (video?.approvalStatus === approvalStatuses.IN_REVIEW.TYPE) {
      return t('review.status.in_review');
    }

    if (video?.approvalStatus === approvalStatuses.DECLINED.TYPE) {
      return t('review.status.decline');
    }

    if (video?.approvalStatus === approvalStatuses.APPROVED.TYPE) {
      return t('review.status.approved');
    }
  }, [video]);

  const isVideoCanBeReviewed = useMemo(() => isApprovalFlowEnabled && isReviewerUser && (isInReviewStatus || isApprovedStatus), [
    isInReviewStatus,
    isApprovedStatus,
    isReviewerUser,
  ]);

  const isAnalyticsNotEmpty = useMemo(() => analyticsInfo?.cta?.length || analyticsInfo?.views?.length, [analyticsInfo]);

  const handleNameChange = () => {
    setSize(editableRef.current.value.length);
  };

  const handleCloseMoveModal = () => {
    setMoveModal(false);
  };

  const handleCloseConfirmMoveModal = () => {
    setConfirmMoveModal(false);
  };

  const handleCloseMenu = () => {
    setShowMenu(false);
  };

  const handleOpenMenu = () => {
    setShowMenu(true);
  };

  const handleClosePreferences = () => {
    setShowPreferences(false);
  };

  const handleOpenPreferences = () => {
    setShowPreferences(true);
  };

  const handleOpenApprovalsFeedback = () => {
    setShowApprovalsFeedback(true);
  };

  const handleCloseApprovalsFeedback = () => {
    setShowApprovalsFeedback(false);
  };

  const handleOpenReviewMode = () => {
    setShowReviewMode(true);
  };

  const handleCloseReviewMode = () => {
    setShowReviewMode(false);
  };

  const updateVideoSettings = async () => {
    const { settings, active } = await VideoService.getVideoDetails(videoId);
    setVideo(prevState => ({ ...prevState, settings, active }));
  };

  const deleteVideo = () => {
    if (isVideoOwner) {
      const confirmDelete = confirm(`Are you sure you want to permanently delete ${video.name}? This can't be undone.`);
      if (confirmDelete) {
        deleteVideoForever();
      }

      return;
    }

    setConfirmDeleteModal(true);
  };

  const deleteVideoForever = async () => {
    try {
      await VideoService.deleteVideoForever(video.id);
      ToastNotification({
        message: `${t('general.toast.delete_successfully')} '${video.name}'`,
        iconName: 'success',
        isMobileView: isMobileView,
      });
      history.push('/eg/dashboard');
    } catch (e) {
      Toast.error(e);
    }
  };

  const duplicateVideo = useCallback(
    async (id, name, sourceType = null) => {
      const loadingToast = ToastNotification({
        message: `${t('general.toast.duplicating')}`,
        spinner: true,
        isMobileView: isMobileView,
        autoClose: false,
      });

      try {
        let folderId = video?.folder ?? null;
        logFirebaseEvent('sd_dup_cl', { story_id: videoId });

        if (folderId) {
          // In fact, the roles presented in isUserHasEditingRights do not quite fit the case of duplication.
          // Because even if isUserHasEditingRights returns true since the role of the owner of the video,
          // then in fact we only care about the role of the user in the folder, since even if he owns this video,
          // he can be a regular viewer in the folder and not have access to change the amount of videos in the folder
          // Therefore, we check exactly the role of the user in the folder
          const { result } = await CmsAPI.getFolder(folderId);

          const folderUser = result?.users?.find(item => item.username === user.username);

          const isFolderOwner = result?.owner?.username === user.username;
          const isFolderAdmin = folderUser?.folderRole === FOLDER_USER_ROLE.EDITOR.TYPE && result?.editingEnabled;

          if (!isFolderOwner && !isFolderAdmin) {
            folderId = null;
          }
        }

        if (latestExternalUpload !== null && sourceType === null) {
          let resultFile = await fetch(latestExternalUpload.url)
            .then(response => {
              if (!response.ok) {
                throw new Error('Failed to fetch video');
              }
              return response.blob(); // Get the file as a Blob
            });
          const newVideoName = `${video.name} ${latestExternalUpload.properties.name}`
          const fileExtension = `.${latestExternalUpload.url.split('?')[0].split('/').pop().split('.').pop()}`;
          await uploadVideoDirectly({
            folderId,
            videoBlob: resultFile,
            videoDuration: null,
            videoName: newVideoName,
            videoExtension: fileExtension,
            onUploadProgress: (e) => console.log('Upload progress', e)
          });

        } else {
          const response = await VideoService.duplicateVideo(id, folderId);
          if (!response) {
            throw `Unexpected response: ${response}`;
          }
        }
        toast.dismiss(loadingToast);
        ToastNotification({
          message: `${t('general.toast.duplicating.successfully')} ${name}`,
          iconName: 'success',
          isMobileView: isMobileView,
        });

        history.push('/eg/dashboard');
      } catch (e) {
        console.log('Error duplicating video', e);
        toast.dismiss(loadingToast);
        Toast.error('Error duplicating video');
      }
    },
    [video, latestExternalUpload, isMobileView]
  );

  const shareVideo = useCallback(async id => {
    try {
      setShareModal({ open: true, videoid: id });
    } catch (e) {
      Toast.error(e);
    }
  }, []);

  const openSearchModal = () => {
    setSearchModal(true);
  };

  const handleCopyClick = async id => {
    if (!document.hasFocus()) {
      document.focus();
    }
    try {
      await navigator.clipboard.writeText(VideoService.getShareURL(id));
      logFirebaseEvent('copy_link_cl', { story_id: id });
      ToastNotification({
        message: t('general.toast.link_copied'),
        iconName: 'success',
        isMobileView: isMobileView,
      });
    } catch (e) {
      console.log('Error copying link', e);
    }
  };

  const onEditClick = useCallback(() => {
    setSize(video.name?.length);
    if (editable.isEdit) return;
    setEditable({
      id: videoId,
      name: video.name,
      isEdit: true,
    });
  }, [editable.isEdit, video.name, videoId]);

  const checkVideoForOriginal = videoDetails => {
    const hlsVideo = ResourceHelper.getResourceByLabel(videoDetails, 'hls')?.url;
    const singleSceneVideo =
      videoDetails.scenes.length === 1 &&
      !videoDetails.hasIntro &&
      !videoDetails.hasOutro &&
      videoDetails.scenes[0].orientation !== 'square';
    return { hlsVideo, singleSceneVideo };
  };

  const requestIsVideoProcessed = async (videoDetails, tries = 0) => {
    if (!pageActiveRef.current) {
      return;
    }
    try {
      let status = '';
      const response = await VideoService.getStoryStatus(videoId);
      status = response.status;

      setCheckedSaveStatus(true);
      if (video.status === 'failed' && status != 'processing') {
        setIsVideoProcessing(false);
        return;
      }

      if (status === 'pending' || status === 'processing') {
        if (queryString.parse(location.search).voiceover) {
          history.replace({ location: location.pathname, search: '' });
        }
        const { hlsVideo, singleSceneVideo } = checkVideoForOriginal(videoDetails);
        if (!hlsVideo && singleSceneVideo && !videoDetails.videoPath) {
          const originalResource = ResourceHelper.getResourceByLabel(videoDetails.scenes[0], 'original');
          videoDetails.videoPath = originalResource?.url;
          await updateVideoData(videoDetails);
        }
        !isVideoProcessing && setIsVideoProcessing(true);

        setTimeout(async () => {
          requestIsVideoProcessed(videoDetails, tries + 1);
        }, tries * 3000);

        return;
      }

      if (status == 'succeeded') {
        // If save status succeeded and tries count === 0 (means that trimming was not triggered)
        // do not request updated videoDetails
        let video = {};
        if (tries > 0) {
          video = await VideoService.getVideoDetails(videoDetails.id);
        } else {
          video = { ...videoDetails };
        }
        const waveformResource = ResourceHelper.getResourceByLabel(video, 'waveform');

        const { hlsVideo, singleSceneVideo } = checkVideoForOriginal(video);

        // Show the original file if no hls generated and the story has only one single scene
        if (!hlsVideo && singleSceneVideo && !videoDetails.videoPath) {
          const originalResource = ResourceHelper.getResourceByLabel(video.scenes[0], 'original');
          video.videoPath = originalResource.url;
          updateVideoData(video);
        }

        if (video.thumbnail === null || (!video.draft && !waveformResource?.url)) {
          !isVideoProcessing && setIsVideoProcessing(true);
          setTimeout(async () => {
            requestIsVideoProcessed({ ...video, videoPath: video.videoPath ?? videoDetails.videoPath }, tries + 1);
          }, tries * 3000);

          return;
        } else {
          if (video.status === 'READY' && video.videoHls === null) {
            const result = await VideoService.checkSceneJobs(video.id, video.scenes[0].id);
            setHasRunningJobs(result.hasRunningJobs);
          }

          setIsVideoProcessing(false);
          if (videoDetails.videoPath) {
            video.videoPath = videoDetails.videoPath;
          } else {
            // Check if video has external videos loaded 
            const hlsResource = ResourceHelper.getResourceByLabel(video, 'hls');
            if (hlsResource?.url) {
              video.videoPath = hlsResource?.url;
            }
          }
          updateVideoData(video);
        }
      }
    } catch (e) {
      console.log('Catch error', e);
    }
  };

  const updateVideoData = async videoDetails => {
    const displayCreateDate = format(new Date(Date.parse(`${videoDetails.createDate}`)), 'dd MMM yyyy');
    const displayUpdateDate = format(new Date(Date.parse(`${videoDetails.updateDate}`)), 'dd MMM yyyy');

    let hlsResource;
    hlsResource = ResourceHelper.getResourceByLabel(videoDetails, 'hls');
    if (hlsResource?.url) {
      videoDetails.video = `${hlsResource?.url}?${Date.now()}`;
    }

    videoDetails.name = parseString(videoDetails.name);

    if (videoDetails?.reactions) {
      setReactions(videoDetails.reactions);
    } else {
      setReactions([]);
    }

    setTags(videoDetails.tags);

    setVideo({ ...videoDetails, displayCreateDate, displayUpdateDate, isInitialized: true });

    videoDetails.description && setDescription(parseString(videoDetails.description));

    if (!videoDetails.draft) {
      const waveformResource = ResourceHelper.getResourceByLabel(videoDetails, 'waveform');

      if (waveformResource) {
        try {
          const waveformResponse = await fetch(waveformResource?.url);
          const waveformData = await waveformResponse.json();
          setWaveform(waveformData);
        } catch (err) {
          console.log('Error while uploading a waveform ', err);
        }
      }
    }
  };

  const onChaptersEditorToggle = async () => {
    await loadVideoChapters();
  };

  const onCallToActionEditorToggle = async () => {
    await loadVideosCtas();
  };

  const loadVideoChapters = async () => {
    try {
      const response = await VideoService.getStoryChapters(videoId);
      const filteredChapters = response.chapters.filter(item => item.startTime <= videoDetails.duration);
      updateInitialChapters(filteredChapters);
    } catch (e) {
      console.log('Error while requesting chapters', e);
    }
  };

  const loadVideosCtas = async () => {
    try {
      const response = await VideoService.getStoryCallActions(videoId);
      const currentActions = getCurrentActions(response, videoDetails.duration);
      updateCallActions(currentActions);
      updateInitialCallActions(currentActions);
    } catch (e) {
      console.log('Error while requesting call to actions', e);
    }
  };

  const loadVideoVoiceovers = useCallback(async () => {
    try {
      changeVoiceoversLoading(true);
      let currentTrack;

      try {
        currentTrack = await VideoService.getStoryVoiceoverTrack(videoId);
      } catch (error) {
        if (error.response?.status === 404) {
          currentTrack = await VideoService.createStoryGeneralVoiceovers(videoId);
        } else {
          throw error;
        }
      }

      const response = currentTrack?.audioSegments ?? [];

      const currentVoiceovers = getCurrentVoiceovers(response, video.duration);

      updateGeneralVoiceoverId(currentTrack.id);
      updateVoiceovers(currentVoiceovers);
      updateInitialVoiceovers(currentVoiceovers);

      if (currentVoiceovers?.length > 0) {
        changeSelectedVoiceover(currentVoiceovers[0]);
      }
    } catch (e) {
      console.log('Error while requesting voiceovers', e);
    }

    changeVoiceoversLoading(false);
  }, [videoId, video, updateGeneralVoiceoverId, updateVoiceovers, updateInitialVoiceovers, changeSelectedVoiceover, changeVoiceoversLoading]);

  const updateVoiceoversListener = useCallback(() => {
    loadDetails(video);
  }, [video]);

  const getVideoAnalytics = async () => {
    try {
      const result = await VideoService.getStoryAnalytics(videoId);
      setAnalyticsInfo(result);
    } catch (err) {
      console.log(err);
    }
  };

  const loadDetails = async (initDetails = null) => {
    if (quiteRecursionRef.current) {
      return;
    }
    let videoPath = '';
    let videoDetails = {};
    try {
      if (initDetails === null) {
        videoDetails = await VideoService.getVideoDetails(videoId);
      } else {
        videoDetails = { ...initDetails };
      }

      if (typeof videoDetails !== 'object') {
        history.push('/eg/dashboard');
        return;
      }

      const externalUploads = ResourceHelper.getAllResourcesByType(videoDetails, 'externalUpload');
      if (externalUploads.length) {
        const latestUpload = externalUploads.pop();
        setLatestExternalUpload(latestUpload);
        setVideoVersion(EDITED);
      }

      if (videoDetails.draft) {
        setIsVideoProcessing(false);
      } else {
        requestIsVideoProcessed(videoDetails);
      }
      if (!videoDetails.duration) {
        videoDetails.duration = videoDetails.scenes[0].trimmedDuration;
      }
    } catch (e) {
      console.log('Error', e);
      history.push('/eg/dashboard');
      return;
    }

    videoDetails.videoPath = videoPath;

    console.log('Video Details in use effect:', videoDetails);
    updateVideoData(videoDetails);
  };

  const getAssignments = async () => {
    try {
      const assignments = await VideoService.getVideoAssignmentsList(videoId);
      setAssignments(assignments);
    } catch (err) {
      console.log(err);
    }
  };

  const getEditorPreference = async () => {
    let preferenceRequest;
    try {
      preferenceRequest = await VormatsAPI.getStoryEditorPreference(videoId);
      setEditorPreference(preferenceRequest);
    } catch (err) {
      Sentry.captureException(err);
    } finally {
      if (!preferenceRequest) {
        setEditorPreference({ editorType: 'basic' });
      }
    }
  };

  useEffect(() => {
    if (appConfig) {
      let appConfigFeatures = appConfig?.features;
      const featureWebAccess = appConfigFeatures?.find(feature => feature.name === 'web_access');
      if (featureWebAccess) {
        if (!featureWebAccess.enabled) {
          history.push('/logout', { web_access_error: true });
          return;
        }
      }
    }
  }, [appConfig]);

  useEffect(() => {
    const fetchData = async () => {
      if (videoDetails?.id != null && !init) {
        await loadDetails(videoDetails);
        setInit(true);
        getVideoAnalytics();
        getAssignments();
        getEditorPreference();
        await loadVideoChapters();
      }
    };

    fetchData();
  }, [videoDetails]);

  const saveVideoName = useCallback(async () => {
    if (!editableRef?.current) {
      return;
    }
    if (editableRef.current.value.length === 0) {
      setEditable(initialState.editable);
      return;
    }
    if (editableRef.current.value.trim().length === 0) {
      setEditable(initialState.editable);
      return;
    }
    if (editable.name === editableRef.current.value) {
      setEditable(initialState.editable);
      return;
    }
    try {
      await VideoService.updateVideo(editable.id, { name: editableRef.current.value.substring(0, 100) });
      console.log('Video name changed!');
    } catch (err) {
      console.log('Err:', err);
      Toast.error('Unable to rename video.');
    } finally {
      const videoDetails = video;
      videoDetails.name = editableRef?.current?.value;
      setEditable(initialState.editable);

      videoDetails.displayCreateDate = format(new Date(Date.parse(`${videoDetails.createDate}`)), 'dd MMM yyyy');
      videoDetails.displayUpdateDate = format(new Date(Date.parse(`${videoDetails.updateDate}`)), 'dd MMM yyyy');

      setVideo(videoDetails);
    }
  }, [initialState, editableRef, editable, setVideo]);

  useEffect(() => {
    const blockNavigation =
      editable.isEdit || isCallToActionOpened || isChaptersEditor || isVoiceoverOpened || isPreferencesEditor || isEditThumbnail;

    let unblock = blockNavigation
      ? history.block(({ pathname, search }) => {
        if (editable.isEdit) {
          // If remaining a video is in progress, block navigation until new name is saved
          saveVideoName().then(() => {
            unblock();
            history.push(pathname);
          });
        } else {
          const showConfirmMessage = isCallActionsChanged || hasChanged;
          if (showConfirmMessage ? confirm(t('clip_organizer.confirm_leave_page')) : true) {
            const parsed = queryString.parse(search);
            if (!parsed.chapters) {
              isChaptersEditor && closeChaptersEditor(false);
            }
            isCallToActionOpened && closeCallToAction(false);
            isVoiceoverOpened && closeVoiceover(false);
            isPreferencesEditor && toggleVideoPreferences(false, false);
            isEditThumbnail && toggleThumbnailEditor(false, false);

            if (isChaptersEditor) {
              loadVideoChapters();
            } else if (isCallToActionOpened) {
              loadVideosCtas();
            }

            // Unblock the navigation.
            return true;
          } else {
            return false;
          }
        }
      })
      : history.block(() => {
        return true;
      });

    return () => unblock();
  }, [
    editable,
    isCallToActionOpened,
    isCallActionsChanged,
    isChaptersEditor,
    isVoiceoverOpened,
    hasChanged,
    isPreferencesEditor,
    isEditThumbnail,
  ]);

  useEffect(() => {
    const handleKeydown = e => {
      // Handle Enter key
      if (e.keyCode === ENTER_KEY_CODE) {
        saveVideoName();
      }
      // Handle Esc key
      if (e.keyCode === ESCAPE_KEY_CODE) {
        setEditable(initialState.editable);
      }
    };

    const saveOnClick = e => {
      if (e.target.id === editableRef.current.id) return;
      saveVideoName();
    };

    if (editable.isEdit) {
      if (editableRef.current) editableRef.current.select();
      document.addEventListener('click', saveOnClick);
      document.addEventListener('keydown', handleKeydown);
    } else {
      document.removeEventListener('click', saveOnClick);
      document.removeEventListener('keydown', handleKeydown);
    }
    return () => {
      document.removeEventListener('click', saveOnClick);
      document.removeEventListener('keydown', handleKeydown);
    };
  }, [editable.isEdit, editable.name, video]);

  const saveVideoDescription = async () => {
    setIsVideoDescriptionProcessing(true);
    try {
      await VideoService.updateVideo(video.id, { description });
      setVideo(prevState => ({ ...prevState, description }));
      setIsVideoDescriptionProcessing(false);
      setIsDescriptionChanged(false);
      ToastNotification({
        message: `${t('general.toast.changed_description')}`,
        iconName: 'success',
        isMobileView: isMobileView,
      });
    } catch (err) {
      console.log('Err:', err);
      Toast.error('Unable to save video description.');
    }
  };

  const archiveVideo = async (id, name) => {
    try {
      await VideoService.updateVideo(id, { archived: 1 });
      ToastNotification({
        message: `${t('general.toast.archive_successfully')} ${name}`,
        iconName: 'archive',
        isMobileView: isMobileView,
      });
      history.push('/eg/dashboard');
    } catch (e) {
      Toast.error('Unable to archive this video.', e);
    }
  };

  const downloadVideo = useCallback(async (sourceType = null) => {
    if (latestExternalUpload && sourceType === null) {
      // Download last uploaded external video
      try {
        fetch(latestExternalUpload.url)
          .then(response => {
            if (!response.ok) {
              throw new Error('Failed to fetch video');
            }
            return response.blob(); // Get the file as a Blob
          })
          .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
              'download',
              `${video.name}_${latestExternalUpload.properties.name}.mp4`
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url); // Clean up the Blob URL
          })
          .catch(error => {
            console.error('Error downloading video:', error);
            ToastNotification({
              message: t('download_modal.fail'),
            });
          });
      } catch (error) {
        console.error(error);
      }
    } else {
      setDownloadModal({ open: true });
    }
  }, [latestExternalUpload, video]);

  const handleMoveVideo = useCallback(
    id => {
      setMoveModal(true);
      setVideoToMove({
        id: video.id,
        name: video.name,
        folder: video.folder,
        isProtected: video.isProtected,
      });
    },
    [video]
  );

  const moveVideo = async () => {
    if (reactLocation?.state?.folder?.users?.length) {
      setMoveModal(false);
      setConfirmMoveModal(true);
      return;
    }

    try {
      const { id, name } = videoToMove;
      if (folderToMove.id === undefined) return;

      await VideoService.updateVideo(id, { folder: folderToMove.id });

      updateFolderToMove({});
      ToastNotification({
        message: `'${name}' ${t('general.toast.succesfully_moved')} '${folderToMove.name}'`,
        iconName: 'success',
        isMobileView: isMobileView,
      });
      setMoveModal(false);
      setVideoToMove({});
    } catch (e) {
      updateFolderToMove({});
      setMoveModal(false);
      console.log('move error');
      // Toast.error(e);
    }
  };

  const confirmMoveVideo = async () => {
    try {
      const { id, name } = videoToMove;
      if (folderToMove.id === undefined) return;

      if (isVideoOwner) {
        await VideoService.updateVideo(id, { folder: folderToMove.id });
      } else {
        await VideoService.claimVideo(id, { folder: folderToMove.id });
      }
      updateFolderToMove({});
      ToastNotification({
        message: `'${name}' ${t('general.toast.succesfully_moved')} '${folderToMove.name}'`,
        iconName: 'success',
        isMobileView: isMobileView,
      });
      setConfirmMoveModal(false);
      setVideoToMove({});
    } catch (e) {
      updateFolderToMove({});
      setConfirmMoveModal(false);
      console.log('move error');
      // Toast.error(e);
    }
  };

  const handleOpenSubmitForReviewModal = () => {
    setShowSubmitForReviewModal(true);
  };

  const handleCloseSubmitForReviewModal = () => {
    setShowSubmitForReviewModal(false);
  };

  const approveVideo = async () => {
    try {
      await VideoService.updateVideoReviewStatus(videoId, { approvalStatus: 4 });
      ToastNotification({
        message: `${video.name} ${t('general.toast.approve.success')}`,
        iconName: 'success',
        isMobileView: isMobileView,
      });
      loadDetails();
    } catch (e) {
      Toast.error(t('general.toast.approve.error'), e);
    }
  };

  const declineVideo = async () => {
    try {
      await VideoService.updateVideoReviewStatus(videoId, { approvalStatus: 3 });
      ToastNotification({
        message: `${video.name} ${t('general.toast.decline.success')}`,
        iconName: 'success',
        isMobileView: isMobileView,
      });
      loadDetails();
    } catch (e) {
      Toast.error(t('general.toast.decline.error'), e);
    }
  };

  const revokeVideo = async () => {
    try {
      await VideoService.updateVideoReviewStatus(videoId, { approvalStatus: 3 });

      ToastNotification({
        message: `${video.name} ${t('general.toast.revoke.success')}`,
        iconName: 'success',
        isMobileView: isMobileView,
      });
      loadDetails();
    } catch (e) {
      Toast.error(t('general.toast.revoke.error'), e);
    }
  };

  const removeFromReviewVideo = async () => {
    try {
      await VideoService.updateVideo(videoId, { approvalStatus: 1 });
      ToastNotification({
        message: `${video.name} ${t('general.toast.remove_from_review.success')}`,
        iconName: 'success',
        isMobileView: isMobileView,
      });
      loadDetails();
    } catch (e) {
      Toast.error(t('general.toast.remove_from_review.error'), e);
    }
  };

  const submitForReviewVideo = async () => {
    try {
      setIsSubmitLoading(true);
      await VideoService.updateVideo(videoId, { approvalStatus: 2 });
      ToastNotification({
        message: `${video.name} ${t('general.toast.submit_for_review.success')}`,
        iconName: 'success',
        isMobileView: isMobileView,
      });
      loadDetails();
    } catch (e) {
      Toast.error(t('general.toast.submit_for_review.error'), e);
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const handleRemoveFromReview = () => {
    removeFromReviewVideo();
    handleCloseApprovalsFeedback();
  };

  const handleOpenAnalyticsInfoModal = () => {
    setShowAnalyticsInfo(true);
  };

  const handleCloseAnalyticsInfoModal = () => {
    setShowAnalyticsInfo(false);
  };

  const handleDelete = obj => {
    reactions?.forEach(reaction => {
      if (reaction.username === user?.username && obj.unicode === reaction.unicode) {
        setReactions(reactions => reactions.filter(item => item.id !== reaction.id));
        setSelectedReactions(reactions => reactions.filter(item => item.id !== reaction.id));
        deleteReaction(reaction);
      }
    });
  };

  const deleteReaction = async reaction => {
    await CmsAPI.deleteReaction(reaction.id).catch(e => {
      console.log(e);
    });
  };

  const addReaction = async reaction => {
    await CmsAPI.insertReaction({
      storyId: video.id,
      username: user.username,
      authorName: user.userFullName,
      unicode: reaction.unicode,
    })
      .then(response => updateReactions(response))
      .catch(e => {
        console.log(e);
      });
  };

  const updateReactions = response => {
    setReactions([...reactions, response.result]);
    if (localStorageStoryReactions) {
      setLocalStorageStoryReactions([...localStorageStoryReactions, response.result.unicode]);
    } else {
      setLocalStorageStoryReactions([response.result.unicode]);
    }
  };

  const handleEditClicked = () => {
    if (editorPreference?.editorType === 'advanced') {
      history.push(`/eg/advanced-editor/${video.id}`);
    } else {
      history.push(`/eg/edit/${video.id}`);
    }
  };

  const handleSaveChapters = useCallback(
    async chapters => {
      try {
        const response = await VideoService.updateStoryChapters(
          videoId,
          chapters.map(item => (item.storyId ? item : { ...item, storyId: videoId }))
        );
        updateInitialChapters(response.chapters);
      } catch (e) {
        console.log('Error while saving', e);
      }
    },
    [videoId]
  );

  const createStatistics = () => {
    let arr = [];
    reactions?.forEach(reaction => {
      let obj = { unicode: '', amount: 0, selected: false };
      if (!arr.some(e => e.unicode === reaction.unicode)) {
        // Check if the emoji already exists in the array
        const isSelected = selectedReactions?.some(el => el.unicode === reaction.unicode); // Check if Emoji is in Selected Array
        obj.unicode = reaction.unicode;
        obj.amount = reactions.filter(function (item) {
          return item.unicode === reaction.unicode;
        }).length;
        obj.selected = isSelected;
        if (reactionStatisticsBar.length > 3 && isSelected && !reactionStatisticsBar?.some(el => el.unicode === reaction.unicode)) {
          arr.unshift(obj);
        } else {
          arr.push(obj);
        }
      }
    });
    setReactionStatistics(arr);
    setReactionStatisticsBar(arr.slice(0, 4));
  };

  const handleReaction = reaction => {
    if (selectedReactions?.some(item => item.unicode === reaction.unicode) && user) {
      // Delete if reaction exist, otherwise add new one
      handleDelete(reaction);
    } else if (user || (!user && !localStorageStoryReactions?.some(unicode => unicode === reaction.unicode))) {
      addReaction(reaction);
    }
  };

  const toggleThumbnailEditor = useCallback(
    (value, updateHistory = true) => {
      if (updateHistory) {
        if (value) {
          history.push({
            pathname: location.pathname,
            search: 'thumbnail=true',
          });
        } else {
          if (location.search.includes('thumbnail=true')) {
            if (history.length > 2) {
              history.goBack();
            } else {
              // Handle cases when page with search parameter was loaded
              history.replace({
                pathname: location.pathname,
                search: '',
              });
            }
          }
        }
      }
      setIsEditThumbnail(value);
    },
    [location, history]
  );

  const toggleVideoPreferences = useCallback(
    (value, updateHistory = true) => {
      if (updateHistory) {
        if (value) {
          history.push({
            pathname: location.pathname,
            search: 'preferences=true',
          });
        } else {
          if (location.search.includes('preferences=true')) {
            if (history.length > 2) {
              history.goBack();
            } else {
              // Handle cases when page with search parameter was loaded
              history.replace({
                pathname: location.pathname,
                search: '',
              });
            }

          }
        }
      }
      setIsPreferencesEditor(value);
    },
    [location, history]
  );


  useEffect(() => {
    createStatistics();
  }, [selectedReactions]);

  useOutsideClick(descriptionRef, () => {
    handleCancelEditDescription();
  });

  const handleCancelEditDescription = () => {
    setIsEditDescription(false);
  };

  const handleOnFocusDescription = () => {
    setShowShareBtn(false);
    setIsEditDescription(true);
  };

  const handleChangeTag = (add = false) => async tagId => {
    setIsTagsLoading(true);
    try {
      let videoTags = [];
      if (add) {
        videoTags = await VormatsAPI.assignTagToStory(tagId, videoId);
      } else {
        videoTags = await VormatsAPI.removeTagFromStory(tagId, videoId);
      }
      setTags(videoTags);
    } catch (e) {
      console.log(e);
    } finally {
      setIsTagsLoading(false);
    }
  };

  useEffect(() => {
    if (
      (videoDetails.description && videoDetails.description !== description) ||
      (!videoDetails.description && description.trim() !== '')
    ) {
      setIsDescriptionChanged(true);
    } else {
      setIsDescriptionChanged(false);
    }
  }, [description]);

  const handleScrollToComment = () => {
    var currentScroll = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    setTimeout(() => {
      window.scrollTo({
        left: 0,
        top: currentScroll + 150,
        behavior: 'smooth',
      });
    }, 200);
  };

  useEffect(() => {
    // Set users selected reactions
    let arr = [];
    reactions?.map(reaction => {
      if (
        reaction.username === user?.username ||
        (!user && reaction.authorName === username && localStorageStoryReactions?.some(unicode => unicode === reaction.unicode))
      ) {
        arr.push(reaction);
      }
    });
    setSelectedReactions(arr);
  }, [reactions, localStorageStoryReactions]);

  useEffect(() => {
    const checkCurrentLocation = location => {
      const parsed = queryString.parse(location.search);
      if (parsed.cta) {
        openCallToAction(false);
        return;
      }

      if (parsed.chapters) {
        openChaptersEditor(false);
        return;
      }

      if (parsed.thumbnail) {
        toggleThumbnailEditor(true, false);
        return;
      }

      if (parsed.preferences) {
        toggleVideoPreferences(true, false);
        return;
      }

      if (parsed.voiceover) {
        openVoiceover(false);
        return;
      }
    };

    history.listen((listenLocation, action) => {
      if (action === 'POP') {
        checkCurrentLocation(listenLocation);
      }
    });

    checkCurrentLocation(location);

    return () => {
      quiteRecursionRef.current = true;
      resetCallActions();
      pageActiveRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (videoDetails.id) {
      const currentActions = getCurrentActions(videoConfig?.ctas, videoDetails.duration);
      updateCallActions(currentActions);
      updateInitialCallActions(currentActions);
    }
  }, [videoConfig, videoDetails])

  if (!checkedSaveStatus && !video.draft) {
    return (
      <>
        <ProtectedPageSidebar />
        <LoaderContent centralized={true} />
      </>
    );
  }

  return (
    <>
      <ProtectedPageSidebar />

      <MobileHeader
        libraryMode={false}
        userAvatar={user?.avatarUri}
        userFirstLetter={user?.userFullName.charAt(0).toUpperCase()}
        openSearchModal={openSearchModal}
      />
      <Content className={cx(styles.videoContainer, { [styles.miniSidebar]: miniSidebar, [styles.mobile]: isMobileView })}>
        <div className={cx(styles.videoContent, { [styles.videoContentViewer]: !isUserHasEditingRights })}>
          {video && !isMobileView && !(isCallToActionOpened || isVoiceoverOpened) && (
            <VideoHeader
              video={video}
              shareVideo={shareVideo}
              handleCopyClick={handleCopyClick}
              deleteVideo={isUserHasAdvancedEditingRights && deleteVideo}
              appConfig={appConfig}
              isVideoProcessing={isVideoProcessing}
              duplicateVideo={((isApprovalFlowEnabled && isReviewerUser) || isUserHasEditingRights) && duplicateVideo}
              moveVideo={isUserHasAdvancedEditingRights && handleMoveVideo}
              archiveVideo={!reactLocation.state?.archive && isVideoOwner && archiveVideo}
              isUserHasEditingRights={isUserHasEditingRights}
              openSubmitForReviewModal={handleOpenSubmitForReviewModal}
              downloadVideo={downloadVideo}
              disableDownload={video.source === 'web' && video?.scenes?.length > 1 && hasHls}
              analyticsInfo={analyticsInfo}
              draft={video.draft}
              editable={editable}
              editableRef={editableRef}
              handleOpenMobileMenu={handleOpenMenu}
              onEditClick={onEditClick}
              isVideoAuthor={true}
              isExternallyEdited={latestExternalUpload !== null}
            />
          )}
          <VideoDetailsPlayer
            src={stateVideoPath}
            video={video}
            hasHls={hasHls}
            isVideoProcessing={isVideoProcessing}
            miniRightSidebar={miniRightSidebar}
            isMobileView={isMobileView}
            commentsWithTimestamp={(videoVersion === null || videoVersion === EDITED) ? commentsWithTimestamp : []}
            handleEditClicked={handleEditClicked}
            isExternallyEdited={latestExternalUpload !== null}
            blockSimulatedResources={videoVersion === EDITED}
            videoVersion={videoVersion}
            videoConfig={videoConfig}
          />
          {isCallToActionOpened && <VideoCallActionsControls storyId={videoId} videoDuration={video.duration} waveform={waveform} />}

          {isVoiceoverOpened && <VideoVoiceoversControls story={video} videoDuration={video.duration} waveform={waveform} />}

          {!isCallToActionOpened && !isVoiceoverOpened && (
            <div className={styles.dataWrapper}>
              {isMobileView ? (
                <div className={styles.titleContainer}>
                  {editable.isEdit ? (
                    <input
                      className={styles.editableTitle}
                      ref={editableRef}
                      type="text"
                      id={video.id}
                      defaultValue={editable.name}
                      onChange={handleNameChange}
                      size={size}
                      maxLength={100}
                      autoFocus
                    />
                  ) : (
                    <h1 className={styles.title}>{video.name || ''}</h1>
                  )}

                  <div className={styles.mobileDotsMenu}>
                    <DotsBtn tagName="BUTTON" onClick={handleOpenMenu} disabled={isVideoProcessing} />
                  </div>
                </div>
              ) : null}

              <div className={styles.userInfoWrapper}>
                <div className={styles.profile}>
                  <Avatar image={video?.author?.avatar} size="large" className={styles.avatar} title={video?.author?.name} alt={`Video's owner avatar`} />
                  {video?.author?.name ? (
                    <span tabIndex={0} className={styles.userName}>{`${t('my_video.by')} ${parseString(video.author.name || '')}`}</span>
                  ) : ''}
                </div>
                {isMobileView ? (
                  Boolean(!isApprovalFlowEnabled || isApprovedStatus || isPreExistedStatus) && (
                      <CustomButton
                        onClick={() => handleCopyClick(video.id)}
                        className={styles.copyLinkMobileBtn}
                        disabled={isVideoProcessing || video.draft}
                        variant="link"
                        ariaLabel={t('general.video_action_button.link_copied')}
                      >
                        <Icon
                          src="mobile_link"
                          verticalAlign="middle"
                          className={cx(styles.sourceIcon, { [styles.disabled]: isVideoProcessing })}
                        />
                      </CustomButton>
                  )
                ) : (
                  <div className={styles.postActions}>
                    <div className={styles.postInfo}>
                      <span tabIndex={0}>{video.displayUpdateDate ? `${t('my_video.last_update')} ${t('general.date', {
                        date: new Date(`${video.displayUpdateDate}`),
                      })}` : ''}</span>
                    </div>

                    <div className={styles.commentActionContainer}>
                      <Reactions
                        user={user}
                        reactions={reactions}
                        handleReaction={handleReaction}
                        selectedReactions={selectedReactions}
                        reactionStatisticsBar={reactionStatisticsBar}
                        reactionStatistics={reactionStatistics}
                      />
                      <CustomButton variant="secondary" className={styles.commentButton} onClick={handleReply}>
                        <Icon src="comment" verticalAlign="middle" className={cx(styles.commentIcon)} />
                        <span>{t('general.comment')}</span>
                      </CustomButton>
                      <CustomButton variant="secondary" className={styles.commentButton} onClick={startAddNotesMode}>
                        <Icon src="addNote" verticalAlign="middle" className={cx(styles.commentIcon)} />
                        <span>{t('my_video.add_note')}</span>
                      </CustomButton>
                      <ReactionPicker handleReaction={handleReaction} isMobileView={isMobileView} isVideoReaction={true} />
                    </div>
                  </div>
                )}
              </div>
              {isMobileView && (
                <div>
                  <div className={styles.commentActionContainer}>
                    {(reactionStatisticsBar && reactionStatisticsBar?.length > 0) ? (
                      <Reactions
                        user={user}
                        reactions={reactions}
                        handleReaction={handleReaction}
                        selectedReactions={selectedReactions}
                        reactionStatisticsBar={reactionStatisticsBar}
                        reactionStatistics={reactionStatistics}
                        isMobileView={isMobileView}
                      />
                    ) : null}
                    <div className={styles.reactionsCommentContainer}>
                      <CustomButton variant="secondary" className={styles.commentButton} onClick={handleReply}>
                        <Icon src="comment" verticalAlign="middle" className={cx(styles.commentIcon)} />
                        <span>{t('general.comment')}</span>
                      </CustomButton>
                      <ReactionPicker handleReaction={handleReaction} isMobileView={isMobileView} isVideoReaction={true} />
                    </div>
                  </div>
                  <div className={styles.postInfoMobile}>
                    {(isAnalyticsNotEmpty && isViewAnalyticsEnabled) ? (
                      <div
                        className={styles.viewsContainer}
                        onClick={handleOpenAnalyticsInfoModal}
                        tabIndex={0}
                        onKeyDown={e => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            handleOpenAnalyticsInfoModal();
                          }
                        }}>
                        <span className={styles.viewsText}>{t('analytics.title')}</span>
                      </div>
                    ) : (
                      <div className={styles.viewsContainer}>
                        <span className={styles.viewsText}>
                            {video?.stats?.views || 0} {t(video?.stats?.views === 1 ? 'general.view' : 'general.views')}
                        </span>
                      </div>
                    )}
                    <span>{`${t('general.date', { date: new Date(`${video.displayUpdateDate}`) })}`}</span>
                  </div>
                </div>
              )}
              {isUserHasEditingRights && (
                <div className={styles.descriptionInput}>
                  <textarea
                    className={cx(styles.descriptionField, {
                      [styles.blurred]: description.trim() === '' && !isDescriptionChanged && !isEditDescription,
                    })}
                    onChange={e => setDescription(e.currentTarget.value)}
                    style={{ transition: 'height 0.3s ease' }}
                    cols="45"
                    ref={descriptionRef}
                    name="text"
                    placeholder={t('my_video.description')}
                    value={description}
                    onBlur={() => isMobileView && !showShareBtn && setShowShareBtn(true)}
                    disabled={
                      (isApprovalFlowEnabled && !isReviewerUser && (isApprovedStatus || isInReviewStatus)) ||
                      isVideoProcessing ||
                      isVideoDescriptionProcessing
                    }
                    tabIndex={0}
                    aria-label={t('my_video.description')}
                    onFocus={handleOnFocusDescription}
                  />
                  {(isEditDescription || isDescriptionChanged) && (
                    <div className={styles.descriptionButtonsContainer}>
                      <CustomButton
                        variant="secondary"
                        label={t('general.post')}
                        disabled={
                          (video.description ? description === video.description : description === '') ||
                          isVideoProcessing ||
                          isVideoDescriptionProcessing
                        }
                        onClick={saveVideoDescription}
                        className={styles.pageButtons}
                      />
                    </div>
                  )}
                </div>
              )}
              {(isUserHasEditingRights && isVideoTagsEnabled && companyTags?.length > 0) && (
                <TagsControls
                  tags={tags}
                  chooseFromOptions={companyTags}
                  className={cx(styles.tagsList, { [styles.disabled]: isTagsLoading })}
                  onSelectTag={handleChangeTag(true)}
                  onRemoveTag={handleChangeTag()}
                />
              )}
              <div className={styles.commentContainer} id="newComment">
                <p className={styles.commentTitle}>{t('my_video.general.comments')}</p>
              </div>
              <Comments
                storyId={videoId}
                user={user}
                username={user?.username}
                author={video.author}
                setShowNewCommentForm={setReply}
                showNewCommentForm={reply}
                chapters={videoVersion === EDITED ? [] : chapters}
                callActions={callActions}
                ignoreTimestampsBefore={latestExternalUpload?.created}
              />
            </div>
          )}
        </div>
        {isMobileView && showShareBtn && (!isApprovalFlowEnabled || isApprovedStatus || isPreExistedStatus) && (
          <div className={styles.shareBtnContainer}>
            <CustomButton
              label={t('general.video_action_button.share')}
              variant="primary"
              onClick={() => shareVideo(video.id)}
              disabled={isVideoProcessing || video.draft}
            />
          </div>
        )}

        <SharingModal open={shareModal.open} onClose={() => setShareModal(initialState.shareModal)}>
          <div className={styles.contentContainer}>
            <SharingModalContent
              onClose={() => setShareModal(initialState.shareModal)}
              videoId={shareModal.videoid}
              anonUrl={shareModal.url}
              anonThumbnailUrl={shareModal.thumbnailURL}
              anonTrackerUrl={shareModal.trackerURL}
              user={user}
            />
          </div>
        </SharingModal>
        {!isMobileView && (isUserHasEditingRights || isVideoCanBeReviewed) ? (
          <VideoSidebarMenu
            video={video}
            isVideoProcessing={isVideoProcessing}
            updateVideoSettings={updateVideoSettings}
            approveVideo={approveVideo}
            declineVideo={declineVideo}
            revokeVideo={revokeVideo}
            removeFromReviewVideo={removeFromReviewVideo}
            isUserHasEditingRights={isUserHasEditingRights}
            draft={video.draft}
            handleEditClicked={handleEditClicked}
            assignments={assignments}
            onChaptersEditorToggle={onChaptersEditorToggle}
            handleSaveChapters={handleSaveChapters}
            onCallToActionEditorToggle={onCallToActionEditorToggle}
            loadVideoVoiceovers={loadVideoVoiceovers}
            updateVoiceoversListener={updateVoiceoversListener}
            isExternallyEdited={videoVersion === EDITED && latestExternalUpload !== null}
            miniRightSidebar={miniRightSidebar}
            setMiniRightSidebar={setMiniRightSidebar}
            isEditingDisabled={isEditingDisabled}
            handleChooseThumbnail={openThumbnailModal}
            isThumbnailProcessing={{ static: customStaticLoading, animated: customAnimatedLoading }}
            isEditThumbnail={isEditThumbnail}
            toggleThumbnail={toggleThumbnailEditor}
            isPreferencesEditor={isPreferencesEditor}
            togglePreferencesEditor={toggleVideoPreferences}
            version={videoVersion}
            handleChangeVersion={setVideoVersion}
            editorPreference={editorPreference}
          />
        ) : null}
        <MoveModal open={moveModal} onClose={handleCloseMoveModal}>
          <MoveModalContent
            handleMoving={moveVideo}
            userId={userId}
            onClose={handleCloseMoveModal}
            video={videoToMove}
            selectedVideos={{}}
            archived={reactLocation?.state?.archive}
            isMobileView={isMobileView}
          />
        </MoveModal>
        <MoveModal open={confirmMoveModal} onClose={handleCloseConfirmMoveModal}>
          <ConfirmMoveModalContent
            confirmMove={confirmMoveVideo}
            contributorsNumber={reactLocation?.state?.folder?.users?.length}
            onClose={handleCloseConfirmMoveModal}
          />
        </MoveModal>
        <CustomThumbnailModal open={customThumbnailModal} onClose={closeThumbnailModal}>
          <CustomThumbnailModalContent
            url={video.videoPath}
            video={video}
            videoDuration={video.duration}
            onSelect={onSelect}
            onCancel={closeThumbnailModal}
            waveform={waveform}
            processing={processingThumbnail}
            staticThumbnail={
              ResourceHelper.getResourceByLabel(video, 'customStaticThumbnail') ??
              ResourceHelper.getResourceByLabel(video, 'defaultStaticThumbnail')
            }
            animatedThumbnail={
              ResourceHelper.getResourceByLabel(video, 'customAnimatedThumbnail') ??
              ResourceHelper.getResourceByLabel(video, 'defaultAnimatedThumbnail')
            }
          />
        </CustomThumbnailModal>
        <DownloadModal open={downloadModal.open} onClose={() => setDownloadModal(initialState.downloadModal)}>
          <div className={styles.contentContainer}>
            <DownloadModalContent
              onClose={() => setDownloadModal(initialState.downloadModal)}
              video={video}
            />
          </div>
        </DownloadModal>
        <DeleteSharedVideoModal
          video={video}
          isShow={confirmDeleteModal}
          confirmDeletion={deleteVideoForever}
          onClose={() => setConfirmDeleteModal(false)}
        />
        <SubmitForReviewModal
          isShow={showSubmitForReviewModal}
          submitVideo={submitForReviewVideo}
          onClose={handleCloseSubmitForReviewModal}
          isSubmitLoading={isSubmitLoading}
        />

        {isMobileView && <>
          <Modal className={styles.viewsContainerModal} open={showAnalyticsInfo} onClose={handleCloseAnalyticsInfoModal}>
            <AnalyticsInfo info={analyticsInfo} onClose={handleCloseAnalyticsInfoModal} isMobileView={isMobileView} />
          </Modal>
          <Modal open={showMenu} onClose={handleCloseMenu} focusTrapped={false} className={styles.modal}>
            <div className={styles.menuContainer}>
              <CardMenu
                menuRef={menuRef}
                listMode={false}
                item={video}
                itemIndex={0}
                handleOpenPreferenses={(isUserHasEditingRights || isVideoCanBeReviewed) && handleOpenPreferences}
                handleOpenApprovalsFeedback={
                  isApprovalFlowEnabled &&
                  !isReviewerUser &&
                  !isPreExistedStatus &&
                  isUserHasEditingRights &&
                  handleOpenApprovalsFeedback
                }
                handleOpenReviewMode={isVideoCanBeReviewed && handleOpenReviewMode}
                toggleShowMenu={handleCloseMenu}
                submitForReview={
                  isApprovalFlowEnabled &&
                  (isConceptStatus || isDeclinedStatus) &&
                  isUserHasEditingRights &&
                  handleOpenSubmitForReviewModal
                }
                renameItem={
                  !reactLocation.state?.archive &&
                  ((isApprovalFlowEnabled && isReviewerUser && isInReviewStatus) ||
                    ((!isApprovalFlowEnabled || (!isApprovedStatus && !isInReviewStatus)) && isUserHasEditingRights)) &&
                  onEditClick
                }
                handleCopyClick={
                  !reactLocation.state?.archive &&
                  (!isApprovalFlowEnabled || isApprovedStatus || isPreExistedStatus) &&
                  !video.draft &&
                  handleCopyClick
                }
                moveItem={isUserHasAdvancedEditingRights && handleMoveVideo}
                downloadItem={{
                  action: (!isApprovalFlowEnabled || isApprovedStatus || isPreExistedStatus) && !video.draft && downloadVideo,
                  disabled: reactLocation.state?.archive,
                  message: t('my_video.download.not_supported_notification'),
                }}
                duplicateItem={((isApprovalFlowEnabled && isReviewerUser) || isUserHasEditingRights) && duplicateVideo}
                archiveItem={!reactLocation.state?.archive && isVideoOwner && archiveVideo}
                deleteVideo={isUserHasAdvancedEditingRights && deleteVideo}
                unarchiveItem={reactLocation.state?.archive && (() => console.log('Unarchive clicked'))}
              />
            </div>
          </Modal>
          <Modal open={showPreferences} onClose={handleClosePreferences} focusTrapped={false} className={styles.modal}>
            <div className={styles.preferencesContainer}>
              <PreferenceList handleClosePreference={handleClosePreferences} video={video} updateVideoSettings={updateVideoSettings} />
            </div>
          </Modal>
          <Modal open={showApprovalsFeedback} onClose={handleCloseApprovalsFeedback} focusTrapped={false} className={styles.modal}>
            <div className={styles.preferencesContainer}>
              <ApprovalsFeedback
                isMobileView
                storyId={video.id}
                reviewer={video.reviewer}
                title={approvalsTitle}
                isPending={isInReviewStatus}
                handleRemoveFromReview={handleRemoveFromReview}
                handleClose={handleCloseApprovalsFeedback}
              />
            </div>
          </Modal>
          <Modal open={showReviewMode} onClose={handleCloseReviewMode} focusTrapped={false} className={styles.modal}>
            <div className={styles.preferencesContainer}>
              <ReviewVideo
                isMobileView
                isPending={isInReviewStatus}
                isApproved={isApprovedStatus}
                storyId={video.id}
                reviewer={video.reviewer}
                handleCloseReviewMode={handleCloseReviewMode}
                approveVideo={approveVideo}
                declineVideo={declineVideo}
                revokeVideo={revokeVideo}
              />
            </div>
          </Modal>
        </>}
      </Content>
    </>
  );
};

export default withProtectionCheck(Video);
